import React, { useEffect } from "react";

import { ValueEditorsFocusManager } from "./ValueEditorsFocusManager";

export function withFocusOnNextValueEditor<P>(WrappedComponent: React.ComponentType<P>): React.ComponentType<P> {
    function FocusOnNextInputWrapper(props: P): JSX.Element {
        useEffect(() => {
            ValueEditorsFocusManager.forceUpdateFocusedByEnterControls();
            return (): void => {
                ValueEditorsFocusManager.forceUpdateFocusedByEnterControls();
            };
        }, []);

        const focusByEnterOnNextControl = (event: React.KeyboardEvent) => {
            if (event.key === "Enter") {
                ValueEditorsFocusManager.focusOnNextValueEditor(event.target);
            }
        };

        return <WrappedComponent focusByEnterOnNextControl={focusByEnterOnNextControl} {...props} />;
    }
    return FocusOnNextInputWrapper;
}
